import script from "./ChatTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatTabs.vue?vue&type=script&setup=true&lang=js"

import "./ChatTabs.vue?vue&type=style&index=0&id=29453974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29453974"]])

export default __exports__